import { AddBlock } from '@clearkit/icons';
import { CKButton, CKSkeleton } from 'clearkit';

import { useProspector } from '../useProspector';
import { isLoading } from '../util';
import ProspectorLists from './ProspectorLists';
import { ProspectorSidebar } from './ProspectorSidebar';
import { SidebarCTAs } from './SidebarCTAs';

export const SidebarLists = () => {
  const [state, send] = useProspector();
  const { id, prospectList, prospectLists } = state.context;

  const hasLists = prospectLists?.length > 0;
  const loading = isLoading(state);

  return (
    <ProspectorSidebar>
      {id ? (
        <ProspectorSidebar.Breadcrumbs>
          {loading ? (
            <CKSkeleton className="h-3 w-[10ch]" />
          ) : (
            prospectList?.name
          )}
        </ProspectorSidebar.Breadcrumbs>
      ) : null}
      {hasLists || loading ? (
        <ProspectorLists list={prospectLists || []} />
      ) : (
        <SidebarCTAs />
      )}
      <ProspectorSidebar.Footer className="flex justify-center">
        <CKButton
          leftIcon={<AddBlock />}
          onClick={() => send('CREATE_PROSPECT_LIST')}
          variant="bold"
          variantColor="blue"
        >
          New Prospect List
        </CKButton>
      </ProspectorSidebar.Footer>
    </ProspectorSidebar>
  );
};
